import React from 'react';

import FakeWPApp from 'Dashboard/components/FakeWPApp/FakeWPApp';
import { AvatarType } from 'Shared/constants/types';
import CreateAccountModal from 'Dashboard/components/Onboarding/CreateAccountModal/CreateAccountModal';

import { WorkspacesType } from '../../types';

type Props = {
  workspaces: WorkspacesType;
  profile: {
    usingWP: Array<string>;
    role: string;
    fullName: string;
    avatar: AvatarType;
  };
  cannotSignIntoGoogle: boolean;
};

function CreateAccount({ workspaces, profile, cannotSignIntoGoogle }: Props) {
  return (
    <>
      <FakeWPApp workspaces={workspaces} currentUser={profile} />
      <CreateAccountModal cannotSignIntoGoogle={cannotSignIntoGoogle} />
    </>
  );
}

export default CreateAccount;
